import { makeStyles } from 'tss-react/mui';
import { BLUE_BG_STYLES } from 'components/Shared/styles';

export const useViewerModeRailStyles = makeStyles()(() => ({
  rail: {
    position: 'absolute',
    top: '50%',
    right: '0.75rem',
    transform: 'translateY(-50%)',
    zIndex: 2000,
    display: 'flex',
    flexDirection: 'column',
    gap: '0.4rem',
    padding: '0.35rem',
    background: 'rgba(255, 255, 255, 0.92)',
    border: '1px solid #d3d8dd',
    borderRadius: '0.75rem',
    boxShadow: '0 4px 14px rgba(0, 0, 0, 0.18)',
  },
  grip: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '0.9rem',
    marginBottom: '0.15rem',
    color: '#9aa3ad',
    cursor: 'grab',
    userSelect: 'none',
    touchAction: 'none',
    '&:active': {
      cursor: 'grabbing',
    },
    '& svg': {
      fontSize: '1rem',
    },
  },
  annotationsToggle: {
    width: '3.1rem',
    height: '2.4rem',
    borderRadius: '0.55rem',
    color: '#9aa3ad',
    '&:hover': {
      background: '#eef2f5',
    },
  },
  presetsButton: {
    width: '3.1rem',
    height: '2.4rem',
    borderRadius: '0.55rem',
    color: '#4b5563',
    '&:hover': {
      background: '#eef2f5',
    },
  },
  annotationsToggleOn: {
    color: '#1f6fb2',
  },
  annotationsBadge: {
    top: 2,
    right: 2,
    minWidth: '1rem',
    height: '1rem',
    padding: '0 0.25rem',
    fontSize: '0.6rem',
    fontWeight: 700,
    lineHeight: '1rem',
  },
  divider: {
    height: 1,
    margin: '0 0.35rem',
    background: '#e3e7eb',
  },
  modeButton: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.1rem',
    width: '3.1rem',
    minWidth: '3.1rem',
    height: '3.1rem',
    padding: '0.2rem 0',
    borderRadius: '0.55rem',
    color: '#4b5563',
    border: '1px solid transparent',
    textTransform: 'none',
    '&.Mui-selected': {
      ...BLUE_BG_STYLES,
      '&:hover': {
        ...BLUE_BG_STYLES,
      },
    },
    '&:hover': {
      background: '#eef2f5',
    },
  },
  modeIcon: {
    fontSize: '1.5rem',
  },
  modeCaption: {
    fontSize: '0.58rem',
    fontWeight: 700,
    letterSpacing: '0.04em',
    lineHeight: 1,
    textTransform: 'uppercase',
  },
  shapeFlyout: {
    position: 'absolute',
    top: 0,
    width: '9.5rem',
    padding: '0.5rem',
    background: 'rgba(255, 255, 255, 0.95)',
    border: '1px solid #d3d8dd',
    borderRadius: '0.6rem',
    boxShadow: '0 4px 14px rgba(0, 0, 0, 0.18)',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.45rem',
  },
  // The flyout opens towards the middle of the slide, away from the edge
  // the rail sits on.
  shapeFlyoutRight: {
    left: 'calc(100% + 0.5rem)',
  },
  shapeFlyoutLeft: {
    right: 'calc(100% + 0.5rem)',
  },
  flyoutSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  flyoutLabel: {
    minWidth: '2.4rem',
    color: '#6b7280',
  },
  swatches: {
    display: 'flex',
    gap: '0.35rem',
    flexWrap: 'wrap',
  },
  swatch: {
    width: '1.1rem',
    height: '1.1rem',
    padding: 0,
    borderRadius: '50%',
    border: '2px solid transparent',
    cursor: 'pointer',
    boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.6)',
  },
  swatchSelected: {
    borderColor: '#2196f3',
    boxShadow: '0 0 0 2px #fff, 0 0 0 3px #2196f3',
  },
  strokeSlider: {
    flex: 1,
    color: '#2196f3',
    padding: '0.4rem 0',
  },
}));
